import CrudApi from '@crudApi';

/**
 * `footer_data` and `configs` are plain JSON columns on the backend (Eloquent
 * casts => 'array'), filled verbatim — NOT relationships. FormData cannot carry an
 * empty array, so a cleared nested collection (e.g. footer_data.attachments = [])
 * is sent as `key[]=""`, which the backend receives as `[null]` and would persist
 * literally into the JSON column. Stripping empty arrays from these two fields before
 * sending keeps the stored JSON clean. Top-level file/relationship collections
 * (e.g. `attachments`) are intentionally left untouched so their clear marker still
 * reaches the relationship handler.
 */
const stripEmptyArraysDeep = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripEmptyArraysDeep);
  }
  if (value && typeof value === 'object' && value.constructor === Object) {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, v]) => !(Array.isArray(v) && v.length === 0))
        .map(([k, v]) => [k, stripEmptyArraysDeep(v)])
    );
  }
  return value;
};

const API = {
  updateQuotationDefaultData: function (data) {
    return CrudApi().post('/api/system-configs/quotation-default-data', data);
  },
  getQuotationDefaultData: function () {
    return CrudApi().get('/api/system-configs/quotation-default-data');
  },
  getSystemTaxActivation: function () {
    return CrudApi().get('/api/system-configs/taxes-types/system-has-taxes');
  },
  getTemplatesVersion: function () {
    return CrudApi().get('/api/system-configs/quotation-templates/versions');
  },
  getTemplateByName: function (templateName) {
    return CrudApi().get(`/api/system-configs/quotation-templates/${templateName}`);
  },
  saveTemplate: function (data) {
    const payload = { ...data };
    if (payload.footer_data !== undefined) payload.footer_data = stripEmptyArraysDeep(payload.footer_data);
    if (payload.configs !== undefined) payload.configs = stripEmptyArraysDeep(payload.configs);
    return CrudApi().post('/api/system-configs/quotation-templates/update', payload);
  }
};

export default API;
